import React from 'react';
import {addField} from 'react-admin';
import TextField from '@material-ui/core/TextField';

const MonthInputBase = ({
                            input,
                            meta,
                            label,
                            options = {},
                            ...rest
                        }) => {
    const {touched, error} = meta || {};

    return (
        <TextField
            {...rest}
            {...options}
            label={label}
            type="month"
            value={input.value || ''}
            onChange={input.onChange}
            error={touched && !!error}
            helperText={touched && error}
            InputLabelProps={{
                shrink: true,
            }}
        />
    );
};

export const MonthInput = addField(MonthInputBase);
